import { motion } from "framer-motion";
import { useParams, Link } from 'react-router-dom'
import CloseIcon from './../../assets/images/icon/close.png';

const ThankYou = () => {
  return (
    <section className="privacy-policy">
            <Link to="/" className="mt-0" style={{ background: '#f7f8fc' }}>
                <img className="close-img" src={CloseIcon} alt="Close" />
            </Link>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="page-header">
                            <h1>Thank You!</h1>
                            <p align="justify">Your enquiry has been submitted successfully. We will get back to you soon.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  );
};

export default ThankYou;